<script>
import MenuHeaderMenu from '../menus/menu-header-menu/MenuHeaderMenu.vue'
import MenuSubMenu from '../menus/menu-sub-menu/MenuSubMenu.vue'
import {EventBus} from "../../event-bus";
import { computed,onMounted,ref,onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'RegionHeader',
  components: {
    MenuHeaderMenu,
    MenuSubMenu,
  },
  setup(){

        const store = useStore();
        const isSearchOpen =  ref(true)
        const disclaimer =  ref(false)
        const classes = computed(() => {
          return [
              'region-header',
              {
                open: store.state.navigation.main,
                "region-header-disclaimer": disclaimer.value
              },
           ]
        });
        const formSearch = computed(() => {return document.getElementById('search-block-form')});
        const isMobile = computed(() => {return document.documentElement.clientWidth < 768});


        function toggleMenu() {
            const mainState = store.state.navigation.main
            store.commit('updateNavigation', { main: !mainState })
            EventBus.$emit("toggleNavMenu");
        };
        function toggleSearch(event) {
            event.preventDefault()
            const input = searchInput.value

            if (input.value) {
              formSearch.submit()
            } else {
              isSearchOpen.value = !isSearchOpen.value
              isSearchOpen.value ? input.focus() : input.blur()
              event.target.classList.toggle('toggled')
            }
        };
        function setSticky() {
            window.addEventListener('scroll', () => {
              const st = window.pageYOffset
              const trigger =isMobile ? 0 : 50
              const action = st > trigger ? 'add' : 'remove'
              document.body.classList[action]('header-sticky')
            })
        };
        function unsetSticky() {
          window.removeEventListener('scroll', navScroll)
        };

        onMounted(() => {
          setSticky()
          if(document.getElementsByClassName("menu-disclaimer").length > 0) {
                if(window.innerWidth < 960) {
                  disclaimer.value = true
                }
            }
        })
        onBeforeUnmount(()=>{
          unsetSticky()
        })

        return  { classes, toggleMenu, toggleSearch, isSearchOpen, disclaimer, unsetSticky, setSticky }
  }
}
</script>
<style lang="sass">
@import ../../common/styles/settings
@import RegionHeader
</style>
